// Page-layout watcher — replaces the old "DevTools" size check (outer − inner > 160 px every 5 s), which
// fired on browser zoom, display scaling and side panels (interview 60: 259 signals, DevTools never open).
// The layout when the interview starts is the baseline. Only a later shrink of the page inside the window
// (> 160 px beyond the baseline) is reported — once when it starts and once when it ends, with a duration.
// A zoom change (devicePixelRatio) becomes the new baseline, not a signal. Information only on the server.
export const LAYOUT_THRESHOLD_PX = 160;

export function readLayout(win = window) {
  return { ow: win.outerWidth, oh: win.outerHeight, iw: win.innerWidth, ih: win.innerHeight, dpr: win.devicePixelRatio || 1 };
}

export function createLayoutWatcher(getLayout, send, now = () => Date.now()) {
  const baseline = getLayout();
  let shrunkSince = null;
  const chrome = (l) => ({ w: l.ow - l.iw, h: l.oh - l.ih });
  return function check() {
    const cur = getLayout();
    if (Math.abs(cur.dpr - baseline.dpr) > 0.01) {          // zoom changed → new baseline
      Object.assign(baseline, cur);
      return;
    }
    const a = chrome(cur);
    const b = chrome(baseline);
    const shrunk = a.w - b.w > LAYOUT_THRESHOLD_PX || a.h - b.h > LAYOUT_THRESHOLD_PX;
    if (shrunk && shrunkSince === null) {
      shrunkSince = now();
      send('viewport_shrank', JSON.stringify({ baseline: { ...baseline }, now: cur }));
    } else if (!shrunk && shrunkSince !== null) {
      send('viewport_restored', JSON.stringify({ duration_seconds: Math.round((now() - shrunkSince) / 1000), now: cur }));
      shrunkSince = null;
    }
  };
}
